module.exports = __webpack_public_path__ + "img/btn_setting.02725c32.png";